import './ComboManagementApp.less';
import React from 'react';
import __ from "../../i18n";
import ComboListParcel from "../../api/endpoints/combo/ComboListParcel";
import FilterConfig from "./config/FilterConfig";
import TableConfig from "./config/TableConfig";
import ManagementTemplate from "../../templates/management/ManagementTemplate";
import routes from "../../routing/routes";
import ComboEditor from "../../editors/combo/ComboEditor";
import ComboBulkDeleteParcel from "../../api/endpoints/combo/ComboBulkDeleteParcel";
import useBreadcrumb from "../../hooks/useBreadcrumb";


export default function ComboManagementApp() {

    useBreadcrumb([
        {name: __('Combo'), url: routes.combo_management.getUrl()}
    ]);

    return <div className="combo-management-app">
        <ManagementTemplate
            title={__('All combos')}
            FilterConfig={FilterConfig}
            TableConfig={TableConfig}
            ListParcel={ComboListParcel}
            BulkDeleteParcel={ComboBulkDeleteParcel}
            refNames={['combo_course', 'course', 'image', 'promotion']}
            getCreateButtonTitle={() => __('Add new combo')}
            getCreateTitle={() => __('Add new combo')}
            getCreateEditor={(onDone, onCancel) => (
                <ComboEditor
                    onDone={onDone}
                    onCancel={onCancel}
                />
            )}
            defaultSorting={{
                key: 'id',
                isAsc: false
            }}
            allowsSelectItems={true}
        />
    </div>;
}
